export default __webpack_public_path__ + "static/media/Co-curricular.562905ac.svg";